<template>
  <div class="container">
    <div class="row no-gutters topRow mt-1">
      <div class="col-md-3 col-sm-auto d-md-block d-none">
        <img
          src="@/assets/images/logo.png"
          width="80px"
          height="80px"
          @click="goHome"
        />
      </div>

      <div class="col-md-6 p-1"></div>

      <div class="col-md-3">
        <div class="row no-gutters justify-content-end">
          <div class="col-6 col-md-7 offset-md-5 p-1">
            <button @click="logOut" class="btn btn-block btn-secondary">
              Log out
            </button>
          </div>

          <div class="col-6 col-md-7 offset-md-5 p-1">
            <FAQMenu />
          </div>
        </div>
      </div>
    </div>

    <main class="">
      <slot />
    </main>

    <footer></footer>
  </div>
</template>

<script>
import FAQMenu from "@/components/FAQMenu";

export default {
  name: "PreRecDefaultLayout",
  computed: {
    sessionName() {
      return this.$store.state.sessionName;
    },

    isHost() {
      return this.$store.getters["auth/isHost"];
    },

    isRecording() {
      return this.$store.getters.isRecording;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/login");
    },
    goHome() {
      this.$router.push("/");
    },
  },
  components: {
    FAQMenu,
  },
};
</script>

<style scoped>
.topRow {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.recFlagSpacer {
  height: 38px;
}

.alert-recording {
  border-width: 3px;
  border-radius: 10px;
  height: 38px;
  color: white;
  background-color: #dc3545;
  border-color: #dc3545;
  padding: 0.25rem 3rem;
}
</style>
